<!--
 * @Author:
 * @Description: 分片上传公用组件
-->
<template>
  <div class="w-full mt-10px">
    <div class="w-full h-240px relative overflow-auto">
      <el-upload
        class="w-full"
        :auto-upload="false"
        action=""
        :on-remove="handleRemove"
        :file-list="fileList"
        :on-change="changeFile"
        :multiple="multipleable"
        :drag="!fileList.length"
      >
        <div v-if="!fileList.length">
          <i class="el-icon-upload text-68px"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </div>
        <div v-else class="text-left">
          <el-button type="primary" size="small">点击上传</el-button>
        </div>
        <div slot="file" slot-scope="{ file }">
          <div>
            <span>{{ file.name }}</span>
            <el-progress :percentage="file.percent" :stroke-width="8" :text-inside="false" />
          </div>
          <span class="el-upload-list_item-actions">
            <span class="el-upload-list_item-delete" @click="handleRemove(file, fileList)">
              <i class="el-icon-close"></i>
            </span>
          </span>
        </div>
      </el-upload>
      <div v-if="fileList.length > 0" class="absolute right-0 top-0">
        <el-button type="danger" size="small" @click="deleteAll">清空</el-button>
        <el-button type="primary" @click="uploadConfirm" size="small" :loading="uploadLoading"
          >确认上传</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import documentManagementService from '@/services/documentManagement'
import fnMixin from '@/assets/js/fnMixins'

export default {
  name: 'newUploadFile',
  mixins: [fnMixin],
  props: {
    initFiles: {
      type: Array,
      default() {
        return []
      },
    },
    multipleable: {
      type: Boolean,
      default: false,
    },
    uploadParams: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      fileList: [],
      accept: ['zip'],
      uploadLoading: false,
      sliceSize: 5 * 1024 * 1024,
      batchKey: '',
      mergeCount: 0,
    }
  },
  watch: {
    initFiles() {
      this.fileList = []
    },
  },
  methods: {
    // 移除文件
    handleRemove(file, fileList) {
      this.fileList = fileList.filter((item) => {
        return item.uid !== file.uid
      })
    },
    changeFile(file, fileList) {
      // 检查文件类型
      const name = file.name
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix) &&
        this.type === 1
      ) {
        this.$message.warning(`上传文件只能是${this.accept.join('、')}`)
        this.fileList = []
        return false
      }

      // 检查文件名重复
      const currentIndex = fileList.findIndex((item) => {
        return item.uid === file.uid
      })
      const duplicateFiles = fileList.filter((item, index) => {
        // 只检查当前文件之前的文件是否重名
        return index < currentIndex && item.name === file.name
      })

      if (duplicateFiles.length > 0) {
        this.$message.warning(`文件"${file.name}"已存在，请勿重复上传`)
        // 从文件列表中移除当前文件
        this.fileList = fileList.filter((item) => {
          return item.uid !== file.uid
        })
        return false
      }

      this.fileList = fileList
      return true
    },
    deleteAll() {
      this.fileList = []
    },
    // 确认上传
    async uploadConfirm() {
      if (!this.fileList.length) {
        this.$message.warning('请选择文件')
        return
      }
      this.mergeCount = 0
      this.batchKey = new Date().getTime().toString()
      this.uploadLoading = true

      /* eslint-disable no-await-in-loop */
      // 顺序上传文件
      for (let i = 0; i < this.fileList.length; i += 1) {
        try {
          await this.customUpload(this.fileList[i])
        } catch (error) {
          console.error('文件上传失败:', error)
          this.uploadLoading = false
          break
        }
      }
    },
    // 分片上传
    customUpload(file) {
      return new Promise((resolve, reject) => {
        console.log(file, 'file')
        let uploadId = ''
        // 初始化进度为0
        this.$set(file, 'percent', 0)
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
        if (['pr', 'pprj'].includes(extension) && file.size > 1024 * 1024 * 500) {
          // 超过500M才提示做关联
          this.$confirm('请通过批量关联功能，同步上传模型的XML数据文件', '提示', {
            showCancelButton: false,
            showConfirmButton: false,
            showClose: true,
            closeOnClickModal: true,
            closeOnPressEscape: true,
            type: 'warning',
            center: true,
          })
        }
        this.calculateMD5(file.raw, this.sliceSize)
          .then(async (md5) => {
            try {
              const blob = file.raw
              const partETags = []
              // eslint-disable-next-line no-unused-vars
              const { size: fileSize, name: fileName } = blob
              const totalSlice = Math.ceil(fileSize / this.sliceSize)
              this.chunktotle = totalSlice

              // 第一步 获取uploadId
              if (!uploadId) {
                const formData = new FormData()
                formData.append('objectKey', md5.toUpperCase())
                formData.append('batchKey', this.batchKey)
                const res = await documentManagementService.chunkUpload(formData)
                if (res && res.code === 0) {
                  uploadId = res.data.uploadId || ''
                }
              }

              /* eslint-disable no-await-in-loop */
              // 第二步 循环上传切片
              for (let i = 0; i < totalSlice; i += 1) {
                await this.$nextTick()
                const progress = Math.floor(((i + 1) / totalSlice) * 100)
                this.$set(file, 'percent', progress)

                const start = i * this.sliceSize
                const chunk = blob.slice(start, Math.min(fileSize, start + this.sliceSize))

                const formData = new FormData()
                formData.append('objectKey', md5.toUpperCase())
                formData.append('batchKey', this.batchKey)
                formData.append('file', chunk)
                formData.append('partNumber', i + 1)
                formData.append('uploadId', uploadId)

                const resChunk = await documentManagementService.chunkUpload(formData)
                if (resChunk && resChunk.code === 0) {
                  partETags.push({
                    partNumber: resChunk.data.partNumber,
                    eTag: resChunk.data.eTag,
                  })

                  if (i + 1 === totalSlice) {
                    await this.chunksMerge(uploadId, md5, partETags, file)
                    resolve() // 合并完成后才进行下一个文件
                  }
                } else {
                  throw new Error('切片上传失败')
                }
              }
              /* eslint-enable no-await-in-loop */
            } catch (error) {
              reject(error)
            }
          })
          .catch((error) => {
            this.$set(file, 'percent', 0)
            this.$message.error(error.message || '上传失败')
            this.uploadLoading = false
            reject(error)
          })
      })
    },
    // 合并分片
    async chunksMerge(uploadId, md5, partETags, file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.'))
      // 先增加合并次数
      this.mergeCount += 1
      // 传参
      const params = {
        batchKey: this.batchKey,
        standardId: this.uploadParams.standardId,
        documentId: this.uploadParams.documentId,
        fileName: file.name,
        md5: md5.toUpperCase(),
        fileSize: file.size,
        fileType,
        objectKey: md5.toUpperCase(),
        partETags,
        uploadId,
      }

      try {
        const res = await documentManagementService.chunkUploadRelationComplete(params)
        console.log(res, 'res')
        if (res && res.code === 0) {
          this.$set(file, 'percent', 100)
          if (this.mergeCount === this.fileList.length) {
            this.$message.success('上传成功')
            this.$emit('uploadSuccess', true)
            this.uploadLoading = false
            this.fileList = []
          }
        } else {
          this.$message.error(res.msg || '合并失败')
        }
      } catch (error) {
        this.$message.error(error.message || '合并失败')
        this.$set(file, 'percent', 0)
        this.uploadLoading = false
      } finally {
        // 最后一个文件处理完成后，重置状态
        if (this.mergeCount === this.fileList.length) {
          this.uploadLoading = false
          this.mergeCount = 0
        }
      }
    },
    // md5 的计算
    calculateMD5(file, chunkSize) {
      return new Promise((resolve, reject) => {
        const chunks = Math.ceil(file.size / chunkSize)
        const spark = new SparkMD5.ArrayBuffer()
        const fileReader = new FileReader()
        let currentChunk = 0

        fileReader.onload = (e) => {
          spark.append(e.target.result) // 更新 MD5 值
          currentChunk += 1
          if (currentChunk < chunks) {
            this.loadNextChunk(fileReader, currentChunk, chunkSize, file)
          } else {
            const md5 = spark.end() // 计算最终 MD5 值
            resolve(md5)
          }
        }
        // eslint-disable-next-line func-names
        fileReader.onerror = function(e) {
          reject(e)
        }
        this.loadNextChunk(fileReader, currentChunk, chunkSize, file)
      })
    },
    // md5 计算
    loadNextChunk(fileReader, currentChunk, chunkSize, file) {
      const start = currentChunk * chunkSize
      const end = Math.min(start + chunkSize, file.size)
      const chunk = file.slice(start, end)
      fileReader.readAsArrayBuffer(chunk)
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-upload {
  width: 100% !important;
  .el-upload-dragger {
    width: 100% !important;
    height: 210px !important;
  }
}
/deep/.el-upload-list {
  padding: 0 10px !important;
}

</style>
